import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AdminNotificationsService } from '../../core/services/admin-notifications.service';
import { AdminTheme, UiPreferencesService } from '../../core/services/ui-preferences.service';

@Component({
  selector: 'app-settings-page',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './settings-page.component.html',
  styleUrl: './settings-page.component.scss',
})
export class SettingsPageComponent implements OnInit, OnDestroy {
  private readonly uiPreferences = inject(UiPreferencesService);
  private readonly notifications = inject(AdminNotificationsService);
  private readonly subscriptions = new Subscription();

  readonly themes: Array<{ label: string; value: AdminTheme }> = [
    { label: 'Système', value: 'system' },
    { label: 'Clair', value: 'light' },
    { label: 'Sombre', value: 'dark' },
  ];

  selectedTheme: AdminTheme = 'system';
  notificationsEnabled = false;
  notificationPermission: NotificationPermission | 'unsupported' = 'unsupported';
  message = '';

  ngOnInit(): void {
    this.selectedTheme = this.uiPreferences.theme;
    this.notificationsEnabled = this.uiPreferences.notificationsEnabled;
    this.notificationPermission = this.notifications.permission;

    this.subscriptions.add(
      this.uiPreferences.theme$.subscribe((theme) => {
        this.selectedTheme = theme;
      })
    );

    this.subscriptions.add(
      this.uiPreferences.notificationsEnabled$.subscribe((enabled) => {
        this.notificationsEnabled = enabled;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  setTheme(theme: AdminTheme): void {
    this.uiPreferences.setTheme(theme);
    this.message = 'Thème mis à jour.';
  }

  setNotificationsEnabled(enabled: boolean): void {
    this.uiPreferences.setNotificationsEnabled(enabled);
    this.message = enabled
      ? 'Notifications activées. Autorise aussi les notifications navigateur.'
      : 'Notifications désactivées.';
  }

  async requestBrowserPermission(): Promise<void> {
    const permission = await this.notifications.requestBrowserPermission();
    this.notificationPermission = permission;
    if (permission === 'granted') {
      this.uiPreferences.setNotificationsEnabled(true);
      this.message = 'Permission notifications accordée.';
      return;
    }
    if (permission === 'denied') {
      this.message = 'Permission refusée dans le navigateur.';
      return;
    }
    this.message = 'Permission non accordée.';
  }

  notificationPermissionLabel(): string {
    if (this.notificationPermission === 'unsupported') {
      return 'Navigateur non compatible.';
    }
    if (this.notificationPermission === 'granted') {
      return 'Autorisées';
    }
    if (this.notificationPermission === 'denied') {
      return 'Refusées';
    }
    return 'À demander';
  }
}
